// Shared price helpers. Written as CommonJS (like slug.js) so both the React
// app and the Node build scripts (generate-merchant-feed.js) use the same logic.
//
// A product can carry its list / MRP price in specs.MRP (e.g. Gronsol, sold at
// 5% off list). When MRP is higher than the selling price the site shows it
// struck through with an "x% OFF" badge. MRP is never shown in the spec table.

const HIDDEN_SPEC_KEYS = ["Datasheet", "MRP"];

function listPrice(p) {
  const raw = p && p.specs && p.specs.MRP;
  const mrp = Number(String(raw == null ? "" : raw).replace(/[^0-9.]/g, ""));
  const price = Number(p && p.price);
  return mrp > 0 && price > 0 && mrp > price ? mrp : null;
}

function discountPct(p) {
  const mrp = listPrice(p);
  return mrp ? Math.round((1 - Number(p.price) / mrp) * 100) : 0;
}

function visibleSpecs(specs) {
  return Object.entries(specs || {}).filter(([k]) => !HIDDEN_SPEC_KEYS.includes(k));
}

module.exports = { HIDDEN_SPEC_KEYS, listPrice, discountPct, visibleSpecs };
